import { render, staticRenderFns } from "./WebApp.vue?vue&type=template&id=4db8be9a&"
import script from "./WebApp.vue?vue&type=script&lang=js&"
export * from "./WebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports